import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/syncProblem.svg';

import styles from './SyncProblemIcon.styles';

type SyncProblemIconProps = {
  className?: string;
};

const useStyles = makeStyles(styles, { name: 'SyncProblemIcon' });

export default function SyncProblemIcon({ className }: SyncProblemIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.root, className)}>
      <Icon />
    </span>
  );
}
